import {useField, useForm} from "vee-validate";
import * as yup from 'yup'
import {useStore} from 'vuex'

export function useCreateUserForm(fn) {

    const store = useStore()
    const fio = store._state.data.auth.loginData.name
    let today = new Date()
    let crDate = `${today.getFullYear()}.${today.getMonth()+1}.${today.getDate()}`

    const {isSubmitting, handleSubmit} = useForm(
        {
            initialValues: {
                contract: 'D-',
                creator: fio,
                creationDate: crDate
            }
        }
    )

    const {value: name, errorMessage: nError, handleBlur: nBlur} = useField('name',
        yup.string()
            .trim()
            .required('Введите ФИО')
    )
    const {value: password, errorMessage: passError, handleBlur: passBlur} = useField('password',
        yup.string()
            .trim()
            .required('Введите пароль')
            .min(8, 'Минимум 8 символов')
    )
    const {value: phone, errorMessage: pError, handleBlur: pBlur} = useField('phone',
        yup.string()
            .required('Введите телефон')
            .trim()
            .length(11, 'Номер состоит из 11 цифр')
    )
    const {value: contract, errorMessage: cError, handleBlur: cBlur} = useField('contract',
        yup.string()
            .required('Введите номер договора')
            .trim()
            .length(6, 'Номер состоит из 6 символов')
    )
    const {value: email, errorMessage: eError, handleBlur: eBlur} = useField(
        'email',
        yup
            .string()
            .trim()
            .email()
            .max(30, 'слишком длинный email')
    )
    const {value: address, errorMessage: aError, handleBlur: aBlur} = useField('address',
        yup.string()
            .required('Введите адрес')
    )
    const {value: equipment, errorMessage: eqError, handleBlur: eqBlur} = useField('equipment',
        yup.string()
            .required('Введите оборудование')
    )
    const {value: validity, errorMessage: vError, handleBlur: vBlur} = useField('validity',
        yup.date()
            .required('Введите срок действия договора')
    )

    const {value: trest} = useField('trest')

    const {value: creator} = useField('creator')
    const {value: creationDate} = useField('creationDate')
    const createUserSubmit = handleSubmit(fn)

    return {
        fio,
        crDate,
        creator,
        creationDate,


        isSubmitting,
        createUserSubmit,
        name,
        password,
        phone,
        contract,
        email,
        address,
        equipment,
        validity,
        trest,
        nError,
        nBlur,
        passError,
        passBlur,
        pError,
        pBlur,
        cError,
        cBlur,
        eError,
        eBlur,
        aError,
        aBlur,
        eqError,
        eqBlur,
        vError,
        vBlur

    }
}